import styled from 'styled-components';

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ListTitle = styled.div.attrs({ className: 'sub_title' })`
  display: flex;
  > span {
    margin-left: 15px;
  }
`;

export const SearchableWrapper = styled.div`
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 20px;
`;
